// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"StudentForms_pageHeader__1819o","depositActions":"StudentForms_depositActions__PIYNU"};